import React from "react";
import { Button } from "./Button";
import "./button.less";

const WideWhiteButton = ({ ...rest }) => {
  return (
    <Button
      className="btn-white lg:w-auto lg:px-70 w-full lg:w-initial"
      {...rest}
    />
  );
};

export default WideWhiteButton;
